export enum PreviewContext {
  CreatorDatabase = "creator-database",
  Dictionary = "dictionary",
}
